export default {
  not_set_up: {
    title: 'Reservierungen sind für diesen Standort noch nicht eingerichtet',
    description:
      'Ein Standort erhält Reservierungen, sobald er mit seinem Google-Eintrag verknüpft ist und einen Inhaber hat. Hat das Restaurant noch keinen Inhaber, legen Sie ihn unter „Team“ an. Bis dahin gibt es hier keine Reservierungs-Öffnungszeiten zum Bearbeiten, und Änderungen an den Öffnungszeiten des Online-Shops werden nicht in die Reservierungen übernommen.',
  },
  company_not_loaded: {
    title: 'Reservierungseinstellungen konnten nicht geladen werden',
    description:
      'Die Reservierungseinstellungen dieses Standorts konnten nicht geladen werden, daher können die Öffnungszeiten für Reservierungen gerade nicht bearbeitet werden. Bitte versuchen Sie es erneut.',
    retry: 'Erneut versuchen',
  },
};
